import React, { useState, useRef, useEffect } from "react";
import { Input, Select, SideSVG } from "../../../common";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowleft.svg";
import { ReactComponent as CompanyAddressSvg } from "../../../../assets/images/signUp/companyAddress.svg";
import Logo from "../../Logo";
import { useSelector, useDispatch } from "react-redux";
import {
  useCreateAddressDetailsMutation,
  useCreateAddressMutation,
  useCreateAddressDetailsUpdateMutation,
} from "../../../../store/Company/companyApiSlice";
import { geoNames } from "../../../../utils/countriesGeonames";
import { setCompanyAddress } from "../../../../store/Company/companySlice";
import { getCountryCode, getStatesByCountryCode, getCitiesByCountryCodeAndStateName } from "../../../../utils/countriesState";
import { setClaimAddressDetails } from "../../../../store/claim/claimSlice";
import WorkingHoursUI from "../../../common/WorkingHoursUI";

const workingHours = [
  "7:00 AM - 3:00 PM",
  "8:00 AM - 3:00 PM",
  "8:00 AM - 4:00 PM",
  "8:00 AM - 5:00 PM",
  "8:00 AM - 6:00 PM",
  "8:30 AM - 5:30 PM",
  "9:00 AM - 5:00 PM",
  "9:00 AM - 6:00 PM",
  "9:00 AM - 7:00 PM",
  "10:00 AM - 6:00 PM",
  "10:00 AM - 7:00 PM",
];

const getStateName = async (stateCode) => {
  const url = `https://secure.geonames.org/childrenJSON?geonameId=${stateCode}&username=teamprp`;
  try {
    const response = await fetch(url);
    const data = await response.json();
    return data.geonames[0].adminName1;
  } catch (error) {
    console.error('Error fetching state name:', error);
    return null;
  }
};

export const CompanyAddress = ({ onNext, onPrev }) => {
  const dispatch = useDispatch();
  const houseNoRef = useRef();
  const localityRef = useRef();
  const areaRef = useRef();
  const postalCodeRef = useRef();
  const cityRef = useRef();
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [countries, setCountries] = useState(getCountryCode());
  const [compContryCode, setCompContryCode] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedHours, setSelectedHours] = useState("Monday to Friday 9AM to 6PM");

  const { companySelectedByUser } = useSelector((state) => state.search);
  const { companyData, companyAddress } = useSelector((state) => state.company);
  const { claimAddressDetails, filledCompany, claimTradeLicenseDetails } = useSelector((state) => state.claims);
  const { token } = useSelector((state) => state.auth);
  const [createAddressDetails, { isLoading }] =
    useCreateAddressDetailsMutation();

  const [setAddressConnection] = useCreateAddressMutation();
  const [addressDetailsUpdate, { isLoading: isUpdatingAddress }] =
    useCreateAddressDetailsUpdateMutation();
  const [stateCode, setStateCode] = useState('');
  const [stateName, setStateName] = useState('');

  const fetchStates = async (code) => {
    try {
      setStates([]);
      setTimeout(async () => {
        setStates(await getStatesByCountryCode(code));
      }, [0])
    } catch (error) {
    }
  };

  const fetchCities = async (code, stateName) => {
    try {
      setCities(getCitiesByCountryCodeAndStateName(code, stateName));
    } catch (error) {
    }
  };

  useEffect(() => {
    const companyDataString = localStorage.getItem('createCompany');
    if (companyDataString != null) {
      const companyDetails = JSON.parse(JSON.stringify(companyDataString));
      const compCountryCode = companyDetails?.country_code;
      if (compCountryCode != undefined)
        setSelectedCountry(compCountryCode);
    }
  }, [])


  useEffect(() => {
    if (selectedCountry != undefined && selectedCountry != "") {
      const selectedCountryData = countries.find(
        (country) => country?.countryCode === selectedCountry
      );
      if (selectedCountryData) {
        fetchStates(selectedCountryData?.countryCode);
      }
    }
  }, [selectedCountry])


  const handleCountryChange = (e) => {
    const selectedCountryValue = e?.target?.value;
    setSelectedCountry(selectedCountryValue);
    setSelectedState("");
    setSelectedCity("");

    const selectedCountryData = countries.find(
      (country) => country?.countryCode === selectedCountryValue
    );

    if (selectedCountryData) {
      setSelectedCountry(selectedCountryData?.countryCode);
      fetchStates(selectedCountryData?.countryCode);
    }
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setStateName(selectedState)

    setSelectedState(selectedState);
    setSelectedCity("");
    setCities([]);
    if (selectedState) {
      fetchCities(selectedCountry, selectedState);
    }
  };

  const handleWorkingHours = (e) => {
    const selectedState = e.target.value;
    setSelectedHours(selectedState);
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setSelectedCity(selectedCity);
  };

  useEffect(() => {
    if (companySelectedByUser) {
      localityRef.current.value = companySelectedByUser?.street || "";
      postalCodeRef.current.value = companySelectedByUser?.postcode || "";
      setSelectedCountry(companySelectedByUser?.country);

      const selectedCountryData = countries.find(
        (country) => country.countryCode === companySelectedByUser?.country
      );

      if (selectedCountryData) {
        fetchStates(selectedCountryData?.countryCode);
        setSelectedState(companySelectedByUser?.state);
      }
    }
  }, [companySelectedByUser, countries]);

  useEffect(() => {
    if (companyAddress || claimAddressDetails || filledCompany?.country_code) {
      houseNoRef.current.value = companyAddress?.address_line_1 || claimAddressDetails?.address_line_1 || "";
      localityRef.current.value = companyAddress?.address_line_2 || claimAddressDetails?.address_line_2  || "";
      postalCodeRef.current.value = companyAddress?.postal_code || claimAddressDetails?.postal_code  || "";
      areaRef.current.value = companyAddress?.area || claimAddressDetails?.area  || "";
      setSelectedHours(companyAddress?.working_hours || claimAddressDetails?.working_hours || "Monday to Friday 9AM to 6PM");
      setSelectedCountry(companyAddress?.country || filledCompany?.country_code || "");
      setSelectedState(companyAddress?.state || claimTradeLicenseDetails?.state?.value || "");
      cityRef.current.value = claimAddressDetails?.city  || "";
      // setSelectedHours(claimAddressDetails?.working_hours || "");

      const selectedCountryData = countries.find(
        (country) => country.countryCode === companyAddress?.country
      );
      if (selectedCountryData) {
        fetchStates(selectedCountryData?.countryCode);
        setSelectedState(companyAddress?.state);
        if (states) {
          fetchCities(selectedCountryData?.countryCode, companyAddress?.state);
          setSelectedCity(companyAddress?.city);
        }
      }
    }
  }, [claimAddressDetails, filledCompany]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (houseNoRef.current.value.trim() === "") {
      errors.houseNo = "Address Line 1 is required.";
    }
    if (cityRef.current.value.trim() === "") {
      errors.city = "City is required.";
    }
    if (selectedState == undefined) {
      errors.state = "State is required.";
    }
    if (selectedState != undefined && selectedState.trim() === "") {
      errors.state = "State is required.";
    }
    if (selectedCountry == undefined) {
      errors.country = "Country is required.";
    }
    if (selectedCountry != undefined && selectedCountry.trim() === "") {
      errors.country = "Country is required.";
    }

    if (selectedHours === "") {
      errors.workingHours = "Working Hours is required.";
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      const jsonData = {
        address_line_1: houseNoRef.current.value,
        address_line_2: localityRef.current.value ? localityRef.current.value : null,
        postal_code: postalCodeRef.current.value,
        area: areaRef.current.value ? areaRef.current.value : null,
        city: cityRef.current.value,
        state: stateName || selectedState,
        country: selectedCountry,
        working_hours: selectedHours,
      };
      
      dispatch(setClaimAddressDetails(jsonData))
      onNext();
    }
  };

  return (
    <section className="relative px-4 sm:px-0 py-20 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo />
          <div className="flex -mx-4">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md py-20 mx-auto">
                <h3 className="font-heading text-f24 sm:text-f30 text-primary font-bold mb-4 text-center punitpunit">
                  Registered Business Address
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className="mb-6">
                    <Input
                      label="Address Line 1"
                      id="houseNo"
                      inputRef={houseNoRef}
                      error={errors.houseNo}
                      placeholder="Suite/Building/Floor No."
                    />
                    <Input
                      label="Address Line 2"
                      id="locality"
                      inputRef={localityRef}
                      error={errors.locality}
                      placeholder="Enter Street/Locality"
                    />
                    <Input
                      label="Area"
                      id="area"
                      inputRef={areaRef}
                      error={errors.area}
                      placeholder="Enter Area"
                    />
                    <div className="flex gap-4 w-full">
                      <Input
                        label="Postal Code"
                        id="postalCode"
                        inputRef={postalCodeRef}
                        placeholder="Enter Postal Code"
                      />

                      <div className="mb-4 w-full">
                        <label
                          htmlFor='country'
                          className="block mb-1 text-primary text-f14 font-semibold text-left"
                        >
                          Country
                        </label>
                        <Select
                          id='country'
                          placeholder="Select a country"
                          value={selectedCountry}
                          onChange={handleCountryChange}
                          disable={true}
                          className={`w-full border ${errors.country ? "border-red-500" : "border-input"
                            } focus:border-primary px-3 py-2 border border-input rounded bg-inputDisable outline-none text-primary`}
                        >
                          <option value="">Select a country</option>
                          {
                            countries
                              ?.sort((a, b) => a.countryName.localeCompare(b.countryName))
                              .map((country) => (
                                <option key={country?.countryName} value={country?.countryCode}>
                                  {country.countryName}
                                </option>
                              ))
                          }
                        </Select>
                        {errors.country && <p className="text-red-500 text-sm text-left">{errors?.country}</p>}
                      </div>
                    </div>
                    <div className="flex gap-4 w-full">
                      {states?.length > 0 ? <Select
                        label="State"
                        id="state"
                        value={selectedState}
                        onChange={handleStateChange}
                        error={errors.state}
                        disable={true}
                        placeholder="Select a state"
                      >
                        <option value="">Select a state</option>
                        {states?.map((state) => (
                          <option key={state.state_code} value={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </Select> : <Input
                        label="State"
                        id="state"
                        inputvalue={selectedState}
                        onInputChange={handleStateChange}
                        error={errors.state}
                        placeholder="Enter a state"
                        disable={true}
                        className={!selectedCountry ? "cursor-not-allowed" : "default"}
                      />}
                      <Input
                        label="City"
                        id="city"
                        inputRef={cityRef}
                        error={errors.city}
                        placeholder="Enter a City"
                      />
                    </div>
                    {/* <Select
                      label="Working Hours"
                      id="workingHours"
                      value={selectedHours}
                      error={errors.workingHours}
                      placeholder="Select working hours"
                      onChange={handleWorkingHours}
                    >
                      <option value="">Select a working hours</option>
                      {workingHours?.map((hours) => (
                        <option key={hours} value={hours}>
                          {hours}
                        </option>
                      ))}
                    </Select> */}
                    <WorkingHoursUI selectedTime ={selectedHours} setSelectedTime={setSelectedHours} error={errors.workingHours}/>
                  </div>
                  {apiError && (
                    <div className="text-left text-red-500 mb-5">
                      {apiError}
                    </div>
                  )}
                  <div className="flex justify-between gap-2">
                    <button
                      className="inline-flex items-center justify-start mr-2 gap-4 text-primaryText font-bold w-full"
                    >
                      <ArrowLeft onClick={onPrev} />

                      <span className="relative" onClick={onPrev}>Go Back</span>
                    </button>
                    <button
                      className={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 `}
                      type="submit"
                    >
                      <span className="relative">
                        {isLoading || isUpdatingAddress ? (
                          <Spinner />
                        ) : (
                          "Save & Continue"
                        )}
                      </span>
                      <ArrowRight />
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <SideSVG SVG={CompanyAddressSvg} positions="bottom-0 left-[-25%]" isScreen={false} />
          </div>
        </div>
      </div>
    </section>
  );
};
